import React from 'react'

function ImageContainer({ source = "", alt = "", className = "", height = 8.5 }) {
    return (
        <div className="w-fit mx-auto md:col-span-3 md:h-full 3xl:w-full flex">
            <img src={source} alt={alt} className={`w-auto md:!h-auto md:w-full 3xl:h-full my-auto ${className}`} style={{ height: `${height}rem` }} />
        </div>
    )
}

export default ImageContainer
